import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "banks container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "banks__title title" }, "Банки и интеграции", -1)
const _hoisted_3 = { class: "banks__content" }
const _hoisted_4 = { class: "banks__list" }
const _hoisted_5 = { class: "banks__block block left" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "block__title" }, "Банки", -1)
const _hoisted_7 = { class: "left__top" }
const _hoisted_8 = ["id"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "left__bottom one-c" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "one-c__desc" }, [
  /*#__PURE__*/_createTextVNode("Загрузка из "),
  /*#__PURE__*/_createElementVNode("b", null, "1С ")
], -1)
const _hoisted_14 = { class: "banks__block block right" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h4", { class: "block__title" }, "Интеграции", -1)
const _hoisted_16 = { class: "block__list" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "block__desc" }

import { IMAGE_BASE_URL } from '@/config'

export default /*#__PURE__*/_defineComponent({
  __name: 'BanksSect',
  setup(__props) {

const integrations = [
  { desc: 'Push-web уведомления', img: 'bell.png' },
  {
    desc: 'E-mail уведомления',
    img: 'mail.png'
  },
  {
    desc: 'Telegram',
    img: 'telegram.png'
  }
]

const banks = [
  {
    img: 'point.png'
  },
  {
    img: 'tinkoff.png'
  },
  { img: 'module.png' }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(banks, (item, index) => {
              return _createElementVNode("li", {
                id: `bank-${index}`,
                key: index,
                class: "left__bank"
              }, [
                _createElementVNode("img", {
                  src: _unref(IMAGE_BASE_URL) + item.img,
                  alt: "Логотип банка"
                }, null, 8, _hoisted_9)
              ], 8, _hoisted_8)
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              src: _unref(IMAGE_BASE_URL) + 'plus.png',
              alt: "Плюс",
              class: "one-c__plus"
            }, null, 8, _hoisted_11),
            _createElementVNode("img", {
              src: _unref(IMAGE_BASE_URL) + 'file.png',
              alt: "Файл",
              class: "one-c__img"
            }, null, 8, _hoisted_12),
            _hoisted_13
          ])
        ]),
        _createElementVNode("li", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("ul", _hoisted_16, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(integrations, (item, index) => {
              return _createElementVNode("li", {
                key: index,
                class: "block__item"
              }, [
                _createElementVNode("img", {
                  src: _unref(IMAGE_BASE_URL) + item.img,
                  alt: "Изображение интеграции"
                }, null, 8, _hoisted_17),
                _createElementVNode("p", _hoisted_18, _toDisplayString(item.desc), 1)
              ])
            }), 64))
          ])
        ])
      ])
    ])
  ]))
}
}

})